import {
  MapFeatureInfo,
  PolygonMapFeatureInfo,
  useLayoutEffect
} from 'ui-components'
import { useDispatch } from '~map-feature-info/states'
import {
  clearSelectedFeature,
  setMapData,
  useFeatureInfo
} from '~map-feature-info/states/map'
import { useCategories } from '~map-preview/states/map'
import { useGeojsonData } from '~map-preview/hooks/useGeojsonData'
import { MS_UUID, getCategoryMarkerStyle } from 'map-style-utils'
import { useMemo } from 'react'
import { Map } from '~map-feature-info/types/__generated/gql/graphql'

type Props = {
  isEmbed: boolean
  map: Map
  title: string
  open: boolean
  isPolygonLayout?: boolean
}

const App = (props: Props) => {
  const {
    map,
    open,
    title,
    isEmbed = false,
    isPolygonLayout = false,
    ...rest
  } = props
  const geojson = useGeojsonData()
  const categories = useCategories()
  const dispatch = useDispatch()
  const feature = useFeatureInfo()

  useLayoutEffect(() => {
    dispatch(setMapData(map))
  }, [dispatch, map])

  const handleCloseEnd = () => {
    dispatch(clearSelectedFeature())
  }

  const updatedFeature = useMemo(
    () => ({
      ...feature,
      properties: (feature.properties ?? []).map((prop) => {
        const isCategory = Object.keys(categories ?? {}).includes(prop.name)
        let categoryStyle: { symbol: object; legend: any } | null = null

        if (isCategory && geojson) {
          categoryStyle = getCategoryMarkerStyle(geojson, {
            aggregateBoundary: MS_UUID,
            aggregateProperty: prop.name,
            selected: feature.id
          })
        }

        return {
          ...prop,
          isCategory,
          categoryStyle:
            categoryStyle?.legend?.classes?.find(
              (style) => style.label === prop.value
            ) || null // Ensure a default value to prevent errors
        }
      })
    }),
    [feature, categories, geojson]
  )

  if (isPolygonLayout)
    return (
      <PolygonMapFeatureInfo
        {...rest}
        isEmbed={isEmbed}
        title={title}
        feature={updatedFeature}
        open={open}
        onCloseEnd={handleCloseEnd}
      />
    )

  return (
    <MapFeatureInfo
      {...rest}
      isEmbed={isEmbed}
      title={title}
      feature={updatedFeature}
      open={open}
    />
  )
}

export { App }
